module.exports = __webpack_public_path__ + "img/Secure.6526d78d.svg";